export default {
  baseUrl: `https://${process.env.REACT_APP_CARGA_APP_API_URL}`
};
